module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("byCmO"))).then(() => parcelRequire('fThBo'));